export const cardDetailsDefault = {
  CARD_NUMBER: '1234 1234 1234 1234',
  CVV: 'CVV',
  EXPIRATION: 'MM/YY',
};
